<template>

  <a :href="href" class="base-button" v-html="settings.label" @click="clicked($event)" v-if="show" />

</template>

<script>
export default {
  name: 'BaseButton',
  props: ['settings'],
  data() {
  return {
    
  }
  },
  computed: {

    href() {
      return this.settings.href ? this.settings.href : '#';
    },
    show() {
      return ( typeof this.settings.hide === 'undefined' || this.settings.hide === false );
    }

  },
  methods: {
  
    clicked(e) {

      if ( this.settings.click ) {

        e.preventDefault();

        this.$emit('clicked',null);

      }

    }

  }
}
</script>